var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowerPot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 206,
    viewBox: "0 0 136 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3134 160.9C24.4004 161.514 21.3298 155.372 21.3298 155.372L10.8898 149.845L12.118 146.775L16.4169 144.318L21.3298 143.09C25.6287 144.114 33.6122 141.862 41.5958 141.862C49.5794 141.862 54.4924 144.932 50.8076 146.775C47.1229 148.617 39.7534 163.97 37.9111 159.671C36.0688 155.372 34.2264 160.285 29.3134 160.9Z",
    fill: "#4F4D40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0317 160.9C29.9447 161.514 33.0153 155.372 33.0153 155.372L43.4553 149.845L42.2271 146.775L37.9282 144.318L33.0153 143.09C28.7164 144.114 20.7329 141.862 12.7493 141.862C4.76566 141.862 -0.147308 144.932 3.53745 146.775C7.22221 148.617 14.5917 163.97 16.434 159.671C18.2763 155.372 20.1187 160.285 25.0317 160.9Z",
    fill: "#4F4D40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6168 0.216587C49.1525 1.22989 48.0054 6.09618 47.067 11.03C46.1298 15.9651 44.4975 20.9579 43.44 22.126C37.5039 28.686 27.0835 63.051 25.8749 80.0523C24.6565 97.1924 28.0501 118.537 34.351 133.369C36.6367 138.746 37.7864 143.309 37.4928 145.827L37.0298 149.799L43.2152 145.911C47.8887 142.973 50.2236 140.375 52.7586 135.295C56.0049 128.789 56.1289 127.8 56.5183 105.231C56.888 83.7911 57.1889 81.084 60.2251 71.925C66.2718 53.6856 65.6048 40.019 58.104 28.4662C54.2829 22.5804 52.1863 15.8165 51.2516 6.3578C50.8119 1.9091 50.0884 -0.810223 49.6168 0.216587Z",
    fill: "url(#paint0_linear_4903_18557)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8822 146.863L38.9827 146.001C39.1611 144.471 38.895 142.491 38.3436 140.304C37.7838 138.083 36.8966 135.523 35.7314 132.782C29.5296 118.183 26.1684 97.0779 27.3711 80.1587C27.9637 71.8231 30.8338 59.106 34.3201 47.6089C36.0593 41.8733 37.94 36.4805 39.7465 32.1287C41.5808 27.7097 43.2621 24.5581 44.5522 23.1324C44.987 22.652 45.3663 21.9325 45.691 21.2044C46.035 20.4331 46.3854 19.4936 46.7244 18.4567C47.4028 16.3813 48.0607 13.8371 48.5406 11.3103L38.8822 146.863ZM38.8822 146.863L42.4169 144.641L43.2152 145.911L42.4169 144.641C44.6782 143.219 46.3097 141.92 47.6733 140.403C49.0384 138.885 50.1856 137.092 51.4165 134.625C53.0064 131.439 53.7662 129.74 54.2214 126.101C54.6943 122.32 54.8231 116.533 55.0185 105.205C55.203 94.507 55.3706 88.3929 55.881 83.8068C56.3985 79.1565 57.2683 76.0777 58.8013 71.453C64.7643 53.466 64.011 40.3187 56.8459 29.283L56.8458 29.2829C52.8563 23.1377 50.7092 16.122 49.7589 6.50531M38.8822 146.863L49.7589 6.50531M49.7589 6.50531C49.7345 6.25888 49.7093 6.01869 49.6835 5.78505M49.7589 6.50531L49.6835 5.78505M49.6835 5.78505C49.3071 7.45992 48.9079 9.37888 48.5406 11.3099L49.6835 5.78505Z",
    stroke: "url(#paint1_linear_4903_18557)",
    strokeOpacity: 0.3,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.011 42.1127L101.011 42.1128C94.1371 45.1602 85.9295 50.2612 78.3727 55.9513C70.8093 61.6464 64 67.8548 59.8737 73.0753L58.6969 72.1452L59.8736 73.0754C54.3268 80.0929 43.398 97.503 38.5341 107.086C36.4577 111.178 35.1359 116.117 34.69 120.876C34.2422 125.657 34.6917 130.103 36.011 133.261C37.313 136.377 37.9665 140.035 37.9937 143.449C38.0046 144.81 37.9161 146.163 37.718 147.449C39.3345 145.353 41.2117 143.057 42.929 141.096C46.1957 137.365 51.5049 130.577 54.7036 126.042C57.9276 121.468 64.1583 112.625 68.5492 106.391C76.9281 94.4916 85.6109 85.2193 99.9681 72.7956C104.678 68.7199 107.511 65.651 109.469 61.9941C111.436 58.322 112.586 53.9392 113.703 47.112L113.703 47.1116C114.128 44.5255 114.786 41.7086 115.506 39.2435C116.215 36.8159 117.021 34.601 117.774 33.295M101.011 42.1127L119.074 34.0439M101.011 42.1127C104.471 40.5783 108.057 38.838 111.053 37.2675C114.008 35.7188 116.504 34.2761 117.699 33.3412C117.728 33.3181 117.758 33.2951 117.787 33.2722M101.011 42.1127L119.294 30.3426C119.287 30.3602 119.279 30.3781 119.271 30.3962C118.939 31.1518 118.418 32.1742 117.787 33.2722M117.774 33.295L119.074 34.0439M117.774 33.295C117.774 33.2952 117.774 33.2954 117.774 33.2956L119.074 34.0439M117.774 33.295C117.778 33.2874 117.783 33.2798 117.787 33.2722M119.074 34.0439C119.636 33.0673 120.122 32.1341 120.477 31.3693C120.463 31.3781 120.448 31.3871 120.433 31.3962C119.734 31.8287 118.796 32.4872 117.787 33.2722M120.671 30.9389C120.485 30.8935 120.236 30.7924 120.009 30.5668L120.671 30.9389Z",
    fill: "url(#paint2_linear_4903_18557)",
    stroke: "url(#paint3_linear_4903_18557)",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.19 101.213L119.19 101.213C121.268 100.061 122.913 99.2397 124.114 98.7297C123.48 99.3405 122.624 100.094 121.53 100.991C117.903 103.961 111.656 110.895 107.6 116.421L108.406 117.013L107.6 116.421C103.055 122.613 99.3982 126.688 95.6214 129.465C91.8693 132.223 87.9461 133.739 82.8024 134.719C78.5218 135.533 72.7013 136.196 69.9033 136.197L69.9029 136.197C67.4996 136.199 65.8183 136.36 63.8805 137.311C62.0178 138.225 59.9562 139.852 56.6893 142.6L56.6891 142.6C52.6601 145.99 46.7906 150.907 43.647 153.527L43.647 153.527C41.1492 155.608 36.9829 158.314 33.3937 160.351C32.4544 160.885 31.5634 161.367 30.7602 161.778C31.5676 161.048 32.4998 160.231 33.4953 159.386L32.848 158.624L33.4954 159.386C36.307 156.998 39.6305 153.046 42.6834 148.696C45.7421 144.337 48.577 139.509 50.3893 135.331L50.3894 135.331C53.1598 128.944 58.5142 124.946 74.7763 117.89C83.3233 114.182 95.6199 109.567 102.076 107.642C108.592 105.699 116.292 102.818 119.19 101.213ZM125.987 98.1274C125.987 98.1275 125.984 98.1275 125.98 98.1271C125.985 98.1271 125.987 98.1273 125.987 98.1274ZM125.399 97.2504C125.402 97.2434 125.403 97.2423 125.401 97.2477C125.4 97.2485 125.4 97.2495 125.399 97.2504Z",
    fill: "url(#paint4_linear_4903_18557)",
    stroke: "url(#paint5_linear_4903_18557)",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2136 136.09L73.2136 136.09C74.3265 135.446 75.1998 134.993 75.8278 134.722C75.8745 134.702 75.9196 134.683 75.963 134.665C75.6251 135.028 75.1246 135.503 74.4474 136.088C72.5769 137.705 69.3652 141.494 67.2863 144.519L67.6984 144.803L67.2863 144.519C64.9545 147.912 63.0724 150.142 61.1196 151.653C59.1807 153.154 57.1461 153.966 54.473 154.474C52.2473 154.898 49.2183 155.227 47.7607 155.211L47.7605 155.211C46.5074 155.197 45.6298 155.275 44.6239 155.789C43.6585 156.282 42.5944 157.168 40.909 158.665L40.9089 158.665C38.8298 160.512 35.801 163.191 34.1787 164.619L34.1787 164.619C32.8891 165.753 30.734 167.222 28.876 168.325C28.2791 168.679 27.7198 168.992 27.2357 169.241C27.7064 168.784 28.2826 168.246 28.9072 167.686L28.5733 167.314L28.9072 167.686C30.3564 166.386 32.0628 164.226 33.626 161.844C35.1924 159.457 36.6384 156.811 37.5554 154.519L37.5554 154.519C38.966 150.993 41.7401 148.818 50.1669 145.025C54.5987 143.03 60.9791 140.558 64.332 139.535C67.7165 138.502 71.7126 136.959 73.2136 136.09ZM76.7323 134.429C76.7322 134.429 76.731 134.429 76.7287 134.429C76.7312 134.429 76.7323 134.429 76.7323 134.429Z",
    fill: "url(#paint6_linear_4903_18557)",
    stroke: "url(#paint7_linear_4903_18557)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82716 0.216587C5.29144 1.22989 6.43862 6.09618 7.37699 11.03C8.31414 15.9651 9.94648 20.9579 11.004 22.126C16.9401 28.686 27.3605 63.051 28.5691 80.0523C29.7875 97.1924 26.3939 118.537 20.093 133.369C17.8072 138.746 16.6576 143.309 16.9511 145.827L17.4142 149.799L11.2288 145.911C6.5553 142.973 4.22041 140.375 1.68532 135.295C-1.56092 128.789 -1.68498 127.8 -2.07433 105.231C-2.44403 83.7911 -2.74495 81.084 -5.78116 71.925C-11.8278 53.6856 -11.1609 40.019 -3.65999 28.4662C0.161074 22.5804 2.25768 15.8165 3.19237 6.3578C3.63208 1.9091 4.35552 -0.810223 4.82716 0.216587Z",
    fill: "url(#paint8_linear_4903_18557)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5617 146.863L15.4612 146.001C15.2829 144.471 15.5489 142.491 16.1003 140.304C16.6602 138.083 17.5474 135.523 18.7125 132.782C24.9144 118.183 28.2756 97.0779 27.0729 80.1587C26.4803 71.8231 23.6102 59.106 20.1239 47.6089C18.3847 41.8733 16.5039 36.4805 14.6975 32.1287C12.8631 27.7097 11.1819 24.5581 9.89176 23.1324C9.45694 22.652 9.07768 21.9325 8.75298 21.2044C8.40901 20.4331 8.05854 19.4936 7.7196 18.4567C7.04116 16.3813 6.38325 13.8371 5.90341 11.3103L15.5617 146.863ZM15.5617 146.863L12.0271 144.641L11.2288 145.911L12.0271 144.641C9.76574 143.219 8.13432 141.92 6.77067 140.403C5.40561 138.885 4.25838 137.092 3.02748 134.625C1.4376 131.439 0.67774 129.74 0.222567 126.101C-0.250296 122.32 -0.379135 116.533 -0.574553 105.205C-0.759029 94.507 -0.926641 88.3929 -1.43701 83.8068C-1.95452 79.1565 -2.82429 76.0777 -4.35736 71.453C-10.3203 53.466 -9.56704 40.3187 -2.4019 29.283L-2.40187 29.2829C1.5877 23.1377 3.73479 16.122 4.6851 6.50531M15.5617 146.863L4.6851 6.50531M4.6851 6.50531C4.70946 6.25888 4.73463 6.01869 4.7605 5.78505M4.6851 6.50531L4.7605 5.78505M4.7605 5.78505C5.13685 7.45992 5.53606 9.37888 5.90333 11.3099L4.7605 5.78505Z",
    stroke: "url(#paint9_linear_4903_18557)",
    strokeOpacity: 0.3,
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-58.4429 50.8244L-58.4427 50.8244C-51.2317 52.9548 -42.432 56.9486 -34.2012 61.6109C-25.9633 66.2773 -18.4065 71.5504 -13.6381 76.1919L-12.5919 75.117L-13.6381 76.1919C-7.22823 82.431 5.86561 98.2772 11.931 107.149C14.5204 110.937 16.4714 115.663 17.5306 120.324C18.5945 125.006 18.7253 129.473 17.8266 132.776C16.9395 136.034 16.7659 139.746 17.1815 143.135C17.3472 144.486 17.6103 145.815 17.9735 147.065C16.099 145.197 13.9398 143.163 11.9828 141.441C8.25995 138.166 2.11542 132.123 -1.64425 128.041C-5.43404 123.924 -12.7587 115.964 -17.9208 110.351C-27.7718 99.6386 -37.5836 91.5703 -53.4304 81.113C-58.6289 77.6824 -61.8355 75.0067 -64.2518 71.6346C-66.6782 68.2485 -68.3862 64.0517 -70.3798 57.4271L-70.3799 57.4267C-71.1358 54.9174 -72.1536 52.2096 -73.1874 49.8587C-74.2054 47.5435 -75.2919 45.4519 -76.2074 44.2545M-58.4429 50.8244L-77.399 45.1656M-58.4429 50.8244C-62.0724 49.7514 -65.8539 48.4909 -69.0285 47.322C-72.1587 46.1695 -74.8206 45.0626 -76.1267 44.2905C-76.159 44.2714 -76.1912 44.2524 -76.2234 44.2335M-58.4429 50.8244L-78.0976 41.5241C-78.0878 41.5406 -78.0777 41.5573 -78.0675 41.5742C-77.6405 42.2804 -76.9915 43.2267 -76.2234 44.2335M-76.2074 44.2545L-77.399 45.1656M-76.2074 44.2545C-76.2073 44.2547 -76.2071 44.2548 -76.207 44.255L-77.399 45.1656M-76.2074 44.2545C-76.2127 44.2475 -76.2181 44.2405 -76.2234 44.2335M-77.399 45.1656C-78.0831 44.2701 -78.6861 43.4078 -79.1372 42.6955C-79.1219 42.7024 -79.1063 42.7094 -79.0905 42.7165C-78.3415 43.0548 -77.3253 43.586 -76.2234 44.2335M-79.3851 42.2939C-79.207 42.2247 -78.9736 42.0923 -78.7777 41.8391L-79.3851 42.2939Z",
    fill: "url(#paint10_linear_4903_18557)",
    stroke: "url(#paint11_linear_4903_18557)",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-73.1064 119.533L-73.1066 119.533C-75.2249 119.029 -76.8275 118.752 -77.9226 118.666C-78.0061 118.659 -78.0856 118.654 -78.1612 118.65C-77.3859 119.21 -76.1422 119.934 -74.3879 120.805C-70.367 122.802 -62.6728 128.381 -57.2397 133.203L-57.9035 133.951L-57.2396 133.203C-51.1298 138.626 -46.6273 141.898 -42.6243 143.582C-38.6821 145.241 -35.1796 145.377 -30.9995 144.393C-27.4728 143.562 -22.8829 141.911 -20.8412 140.762L-20.8407 140.762C-19.0185 139.738 -17.5819 139.163 -15.5786 139.496C-13.7276 139.804 -11.4367 140.888 -7.81644 142.754L-7.81621 142.754C-3.32853 145.069 3.20007 148.417 6.69033 150.193L6.69037 150.193C9.4449 151.595 13.7153 153.036 17.2688 153.933C18.4416 154.229 19.5149 154.461 20.4137 154.612C19.276 153.936 17.8008 153.116 16.2017 152.28L16.665 151.394L16.2017 152.28C13.046 150.631 8.8383 147.352 4.66843 143.498C0.484761 139.632 -3.72785 135.126 -6.88852 130.969L-6.88854 130.969C-9.37409 127.7 -12.0438 125.504 -15.9231 123.924C-19.8473 122.325 -25.0463 121.341 -32.6257 120.59C-40.6102 119.799 -51.7768 119.514 -57.4028 119.949C-60.2913 120.173 -63.4835 120.239 -66.305 120.167C-69.1025 120.096 -71.6153 119.887 -73.1064 119.533ZM-78.9704 117.921C-78.9705 117.921 -78.9695 117.923 -78.9671 117.927C-78.9691 117.923 -78.9703 117.922 -78.9704 117.921Z",
    fill: "url(#paint12_linear_4903_18557)",
    stroke: "url(#paint13_linear_4903_18557)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.08129 62.9609C-10.4384 52.5701 -11.7006 47.9339 -13.7456 34.7052L-13.7457 34.7051C-14.3296 30.9297 -14.7399 28.017 -14.9843 25.9136C-14.1649 26.7311 -13.1706 27.6565 -12.0515 28.6479C-9.32368 31.0644 -5.79886 33.9218 -2.12842 36.6449L-2.1284 36.6449C5.30683 42.1609 9.72658 45.6913 12.9578 49.0853C16.1532 52.4419 18.2226 55.7042 20.8753 60.7562C24.8834 68.3905 27.418 80.9854 27.894 96.4169C28.0852 102.628 29.0568 108.377 30.8443 113.795L30.8443 113.795C33.404 121.552 34.9084 126.711 35.6049 130.448C36.2958 134.155 36.1639 136.326 35.5607 138.163C35.0655 139.669 34.8496 141.695 34.8457 143.978C34.8423 145.943 34.9965 148.171 35.3038 150.547C35.2023 150.358 35.1022 150.176 35.0029 150.002C34.3489 148.855 33.6723 147.921 32.8128 147.237C31.045 145.83 28.8723 145.798 26.0425 145.81C19.4192 145.837 12.6987 140.971 8.54141 132.413L8.54134 132.413C6.74748 128.721 4.90705 122.048 3.36581 113.889C1.83256 105.772 0.619476 96.3188 0.0331111 87.1481C-0.28532 82.1667 -0.604675 78.9528 -1.46828 75.5412C-2.32688 72.1493 -3.7111 68.6118 -6.08129 62.9609ZM-6.08129 62.9609L-7.46459 63.5409L-6.08129 62.9609Z",
    fill: "url(#paint14_linear_4903_18557)",
    stroke: "url(#paint15_linear_4903_18557)",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2175 121.124C21.0737 124.602 21.6254 127.795 22.9025 130.763L22.9026 130.763C24.6894 134.915 25.6909 137.644 26.0866 139.615C26.4714 141.531 26.2622 142.623 25.7085 143.585C25.1887 144.487 24.8958 145.673 24.7774 146.972C24.6577 148.286 24.7103 149.785 24.9341 151.364C24.9341 151.364 24.9341 151.364 24.9341 151.364L24.9746 151.651C24.0778 150.304 23.2997 149.345 22.2156 148.821C21.5311 148.49 20.7876 148.358 19.937 148.317C19.0972 148.277 18.0849 148.326 16.8447 148.401C10.8962 148.76 5.47023 146.26 2.48094 141.905L2.48085 141.904C1.19397 140.03 -0.0216025 136.518 -0.923597 132.113C-1.81785 127.746 -2.3794 122.626 -2.42769 117.63C-2.45407 114.896 -2.56665 113.08 -3.15214 111.172C-3.73024 109.287 -4.75411 107.364 -6.47906 104.371C-8.07482 101.602 -9.0563 99.6331 -9.77888 97.4824C-10.5037 95.3249 -10.9816 92.9445 -11.5256 89.3359L-11.5256 89.3358C-11.8681 87.0655 -12.0795 85.3847 -12.1695 84.2424C-12.0705 84.3106 -11.9671 84.38 -11.8598 84.4506C-11.1411 84.9234 -10.1991 85.4774 -9.10684 86.0756C-6.91958 87.2736 -4.08119 88.6751 -1.11437 89.9951L-1.11435 89.9951C4.90736 92.6742 8.47548 94.406 11.0402 96.1177C13.5618 97.8005 15.1312 99.4763 17.1091 102.106C20.0404 106.005 21.5655 112.692 21.2175 121.124ZM21.2175 121.124L22.2167 121.165M21.2175 121.124L22.2167 121.165M22.2167 121.165C22.5686 112.638 21.0427 105.674 17.9083 101.505L25.9242 151.224C25.4941 148.189 25.7349 145.542 26.5751 144.084C27.9874 141.63 27.3925 138.666 23.8211 130.368C22.6084 127.549 22.0784 124.507 22.2167 121.165Z",
    fill: "url(#paint16_linear_4903_18557)",
    stroke: "url(#paint17_linear_4903_18557)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6925 78.959L59.6925 78.959C58.443 87.0982 57.6206 89.9298 54.6869 96.2749L59.6925 78.959ZM59.6925 78.959C60.0607 76.5622 60.3111 74.7336 60.4498 73.4342M59.6925 78.959L60.4498 73.4342M60.4498 73.4342C59.843 73.9699 59.0777 74.5889 58.2033 75.2561C56.2975 76.7101 53.8315 78.4243 51.2603 80.0528L51.2603 80.0528C46.0498 83.3527 42.9595 85.4682 40.7149 87.5155C38.5003 89.5354 37.0848 91.5114 35.2792 94.5882C32.5667 99.2109 30.9583 106.925 30.8575 116.454C30.817 120.315 30.2106 123.88 29.0134 127.228L29.0134 127.228C27.3104 131.989 26.3238 135.146 25.8888 137.431C25.459 139.688 25.5877 140.996 26.0322 142.109L60.4498 73.4342ZM26.3747 150.176C26.5157 149.928 26.6528 149.699 26.7879 149.488C27.2436 148.776 27.72 148.199 28.3275 147.784C29.5425 146.956 31.0378 146.969 33.0502 147.02C37.8684 147.142 42.5614 144.183 45.3516 139.021L45.3517 139.021C46.5581 136.789 47.7611 132.713 48.7318 127.691C49.6965 122.702 50.4132 116.879 50.6888 111.222C50.8387 108.143 51.0172 106.14 51.5854 104.02C52.1493 101.916 53.0872 99.7339 54.6869 96.275L26.3747 150.176ZM26.3747 150.176C26.5871 148.585 26.6769 147.088 26.6415 145.773C26.6032 144.349 26.4165 143.069 26.0324 142.109L26.3747 150.176Z",
    fill: "url(#paint18_linear_4903_18557)",
    stroke: "url(#paint19_linear_4903_18557)",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6465 152.033C23.8226 151.349 22.9534 150.632 22.0521 149.894L22.3689 149.507L22.0521 149.894C19.1263 147.498 16.1573 144.849 13.7113 142.494C11.2769 140.149 9.32719 138.063 8.46905 136.8L8.46902 136.8C5.66314 132.669 -2.81726 123.882 -10.6417 117.025C-12.1602 115.694 -13.17 114.944 -14.1215 114.529C-15.0518 114.124 -15.9631 114.023 -17.3216 114.083L-17.3434 113.583L-17.3216 114.083C-19.6087 114.183 -21.2845 115.102 -22.3627 116.728C-23.457 118.377 -23.9765 120.817 -23.7862 124.02L-23.7862 124.02C-23.4301 130.019 -20.8197 135.04 -15.4448 139.937C-12.5901 142.537 -10.0464 144.216 -6.62454 145.413C-3.18404 146.616 1.1654 147.34 7.64945 147.987C15.6676 148.787 20.6179 149.877 24.6465 152.033Z",
    fill: "url(#paint20_linear_4903_18557)",
    stroke: "url(#paint21_linear_4903_18557)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5727 158.606C30.4967 153.924 29.727 150.344 26.2689 143.236C22.3751 135.232 21.6865 131.952 22.7853 126.634C23.8215 121.62 25.957 118.143 29.5437 115.632C33.3434 112.972 36.492 113.012 38.3687 115.744C39.4482 117.316 39.5646 118.206 39.0501 120.963C37.7251 128.064 35.4657 136.297 33.9606 139.509C33.0874 141.373 31.757 147.013 30.9729 152.175C30.1956 157.293 29.4655 161.327 29.3496 161.14C29.2345 160.953 29.335 159.813 29.5727 158.606Z",
    fill: "url(#paint22_linear_4903_18557)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8305 116.042L29.8304 116.042C26.3658 118.468 24.2901 121.823 23.2749 126.735C22.7356 129.345 22.6402 131.423 23.1442 133.825C23.6523 136.246 24.7743 139.021 26.7186 143.017C28.4529 146.582 29.5309 149.297 30.0529 151.726C30.1619 152.233 30.2465 152.726 30.3079 153.212C30.3644 152.848 30.4213 152.477 30.4786 152.1C30.8727 149.506 31.4039 146.792 31.9467 144.49C32.4859 142.205 33.0466 140.281 33.5079 139.297L33.5079 139.297C34.9847 136.145 37.2351 127.965 38.5586 120.872C38.8155 119.495 38.8999 118.652 38.8114 117.974C38.726 117.32 38.4743 116.781 37.9566 116.027C37.1017 114.783 35.9907 114.183 34.671 114.166C33.3202 114.149 31.6858 114.743 29.8305 116.042Z",
    stroke: "url(#paint23_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5479 157.756C32.3474 155.385 32.6911 153.485 32.0239 149.597C31.2728 145.219 31.5992 143.479 33.6777 140.788C35.6375 138.252 37.9872 136.578 41.1139 135.49C44.4264 134.337 46.6183 134.544 47.2577 136.071C47.6254 136.949 47.4875 137.417 46.4484 138.816C43.7726 142.416 40.1645 146.547 38.3208 148.122C37.251 149.036 34.9313 151.879 33.1113 154.507C31.307 157.113 29.8026 159.16 29.7676 159.056C29.7332 158.952 30.0844 158.367 30.5479 157.756Z",
    fill: "url(#paint24_linear_4903_18557)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4484 138.816C43.7726 142.416 40.1645 146.547 38.3208 148.122C37.251 149.036 34.9313 151.879 33.1113 154.507C32.8554 154.877 32.6055 155.235 32.365 155.578C32.5122 155.179 32.6246 154.767 32.703 154.334C32.7088 154.302 32.7145 154.269 32.72 154.236M46.4484 138.816L46.0471 138.517M46.4484 138.816L46.0471 138.517C46.0471 138.517 46.0471 138.517 46.0471 138.517M46.4484 138.816C47.4875 137.417 47.6254 136.949 47.2577 136.071C46.6183 134.544 44.4264 134.337 41.1139 135.49C37.9872 136.578 35.6375 138.252 33.6777 140.788M46.0471 138.517C43.3782 142.108 39.7966 146.204 37.9961 147.742L37.9961 147.742C37.4236 148.231 36.5515 149.202 35.61 150.356C34.6708 151.507 33.6399 152.868 32.7291 154.181M46.0471 138.517C46.5709 137.813 46.8111 137.412 46.901 137.107C46.9753 136.855 46.9549 136.643 46.7965 136.264L46.7965 136.264C46.5698 135.723 46.0631 135.36 45.1411 135.273C44.2019 135.184 42.9045 135.396 41.2783 135.962L41.2783 135.962C38.24 137.019 35.9718 138.637 34.0734 141.094M32.7291 154.181C32.7262 154.199 32.7231 154.218 32.72 154.236M32.7291 154.181C32.7195 154.195 32.7098 154.209 32.7002 154.223L32.72 154.236M32.7291 154.181C32.9385 152.876 32.8411 151.402 32.5167 149.512M32.72 154.236L32.7002 154.223C32.4313 154.611 32.1692 154.987 31.9177 155.344L33.6777 140.788M29.7676 159.056C29.7701 159.063 29.7799 159.06 29.7966 159.046L29.7676 159.056ZM29.7676 159.056C29.7505 159.004 29.8287 158.834 29.9687 158.6C29.9722 158.602 29.9757 158.603 29.9792 158.605C30.0285 158.627 30.0701 158.656 30.1048 158.687C29.9513 158.882 29.8453 159.006 29.7969 159.046L29.7676 159.056ZM32.5167 149.512L32.0239 149.597L32.5167 149.512ZM32.5167 149.512C32.1433 147.335 32.0508 145.879 32.2811 144.652C32.5084 143.441 33.0593 142.407 34.0734 141.094M34.0734 141.094L33.6777 140.788M34.0734 141.094C34.0734 141.094 34.0734 141.094 34.0734 141.094L33.6777 140.788",
    stroke: "url(#paint25_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5248 157.489C19.7033 155.141 19.3522 153.279 20.0171 149.496C20.7655 145.237 20.4323 143.532 18.3285 140.867C16.3449 138.354 13.9696 136.676 10.8114 135.555C7.46561 134.368 5.2537 134.529 4.6118 136.008C4.24256 136.858 4.38274 137.317 5.43458 138.702C8.14324 142.267 11.794 146.367 13.6583 147.939C14.7401 148.851 17.0876 151.67 18.9304 154.269C20.7572 156.846 22.2801 158.873 22.3152 158.772C22.3497 158.671 21.994 158.094 21.5248 157.489Z",
    fill: "url(#paint26_linear_4903_18557)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6118 136.008C5.2537 134.529 7.46561 134.368 10.8114 135.555C13.9696 136.676 16.3449 138.354 18.3285 140.867M4.6118 136.008L19.5246 149.41M4.6118 136.008C4.24256 136.858 4.38274 137.317 5.43458 138.702L4.6118 136.008ZM18.3285 140.867L17.936 141.177M18.3285 140.867L17.936 141.177M18.3285 140.867C20.4323 143.532 20.7655 145.237 20.0171 149.496M17.936 141.177C18.9633 142.478 19.5204 143.497 19.7517 144.68C19.986 145.877 19.8966 147.293 19.5246 149.41M17.936 141.177C16.0136 138.742 13.718 137.117 10.6442 136.026L10.6442 136.026C8.99988 135.443 7.68605 135.211 6.73405 135.28C5.79473 135.349 5.292 135.696 5.07044 136.207L5.07043 136.207C4.91349 136.568 4.89496 136.768 4.96849 137.008C5.05925 137.306 5.30188 137.701 5.83269 138.399C8.53427 141.955 12.1587 146.021 13.9806 147.557L13.9806 147.557C14.5585 148.044 15.4403 149.007 16.3932 150.151C17.3461 151.296 18.3927 152.648 19.3166 153.95C19.1066 152.674 19.203 151.24 19.5246 149.41M20.0171 149.496L19.5246 149.41M20.0171 149.496C19.5859 151.949 19.582 153.594 20.1292 155.088L20.0171 149.496Z",
    stroke: "url(#paint27_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4647 161.697C13.8818 160.227 12.8435 158.642 12.0066 154.894C11.0639 150.673 10.1022 149.227 7.13708 147.572C4.34148 146.013 1.50409 145.374 -1.84244 145.55C-5.38783 145.737 -7.3686 146.735 -7.39426 148.346C-7.40909 149.273 -7.10337 149.644 -5.60096 150.519C-1.73216 152.772 3.21226 155.158 5.53682 155.895C6.8858 156.322 10.1349 158.025 12.8339 159.719C15.5095 161.398 17.6932 162.685 17.6869 162.579C17.6802 162.473 17.1301 162.076 16.4647 161.697Z",
    fill: "url(#paint28_linear_4903_18557)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.39426 148.346C-7.3686 146.735 -5.38783 145.737 -1.84244 145.55C1.50409 145.374 4.34148 146.013 7.13708 147.572M-7.39426 148.346L11.5186 155.003M-7.39426 148.346C-7.40909 149.273 -7.10337 149.644 -5.60096 150.519L-7.39426 148.346ZM7.13708 147.572L6.89348 148.009M7.13708 147.572L6.89348 148.009M7.13708 147.572C10.1022 149.227 11.0639 150.673 12.0066 154.894M6.89348 148.009C8.3414 148.817 9.24683 149.545 9.91392 150.548C10.5897 151.564 11.0502 152.906 11.5186 155.003M6.89348 148.009C4.18408 146.498 1.44095 145.878 -1.81612 146.05L-1.81614 146.05C-3.55853 146.141 -4.86082 146.431 -5.71335 146.861C-6.55452 147.284 -6.88546 147.798 -6.89432 148.354L-6.89432 148.354C-6.90062 148.748 -6.84123 148.94 -6.68096 149.134C-6.48311 149.374 -6.10753 149.645 -5.34934 150.087C-1.49065 152.334 3.41612 154.699 5.68782 155.418L5.68786 155.418C6.40837 155.647 7.59221 156.198 8.91121 156.889C10.2301 157.58 11.7154 158.428 13.0679 159.275C12.3846 158.178 11.9235 156.816 11.5186 155.003M12.0066 154.894L11.5186 155.003M12.0066 154.894C12.5493 157.325 13.1767 158.846 14.2551 160.015L12.0066 154.894Z",
    stroke: "url(#paint29_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9149 159.314C27.1118 158.097 26.9894 157.113 27.3891 155.092C27.8391 152.815 27.7214 151.915 26.7929 150.533C25.9173 149.232 24.8383 148.379 23.3782 147.837C21.8313 147.262 20.7869 147.385 20.451 148.182C20.2577 148.64 20.3131 148.882 20.7762 149.6C21.9687 151.449 23.5922 153.567 24.4332 154.371C24.9212 154.837 25.9609 156.296 26.7682 157.647C27.5685 158.986 28.2385 160.037 28.2573 159.983C28.2759 159.929 28.1217 159.628 27.9149 159.314Z",
    fill: "url(#paint30_linear_4903_18557)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.204 148.306L23.204 148.306C22.4645 148.031 21.903 147.946 21.519 147.991C21.1616 148.034 20.9955 148.177 20.9117 148.376L20.9117 148.376C20.8373 148.552 20.8395 148.614 20.8548 148.681C20.8804 148.793 20.9624 148.966 21.1964 149.329C22.3829 151.168 23.981 153.247 24.7787 154.009L24.7787 154.009C25.0604 154.279 25.4663 154.795 25.8881 155.387C26.1448 155.747 26.4156 156.147 26.6797 156.557C26.7076 156.089 26.7836 155.576 26.8986 154.995L23.204 148.306ZM23.204 148.306C24.5653 148.811 25.5603 149.597 26.3779 150.812L23.204 148.306ZM27.1122 152.542C27.0365 151.963 26.8173 151.466 26.3779 150.813L27.1122 152.542ZM27.1122 152.542C27.1903 153.139 27.1216 153.866 26.8986 154.995L27.1122 152.542Z",
    stroke: "url(#paint31_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3134 160.9C24.4004 161.514 21.3298 155.372 21.3298 155.372L10.8898 149.845L12.118 146.775L16.4169 144.318L21.3298 143.09C25.6287 144.114 33.6122 141.862 41.5958 141.862C49.5794 141.862 54.4924 144.932 50.8076 146.775C47.1229 148.617 39.7534 163.97 37.9111 159.671C36.0688 155.372 34.2264 160.285 29.3134 160.9Z",
    fill: "#4F4D40"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0317 160.9C29.9447 161.514 33.0153 155.372 33.0153 155.372L43.4553 149.845L42.2271 146.775L37.9282 144.318L33.0153 143.09C28.7164 144.114 20.7329 141.862 12.7493 141.862C4.76566 141.862 -0.147308 144.932 3.53745 146.775C7.22221 148.617 14.5917 163.97 16.434 159.671C18.2763 155.372 20.1187 160.285 25.0317 160.9Z",
    fill: "#4F4D40"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6168 0.216587C49.1525 1.22989 48.0054 6.09618 47.067 11.03C46.1298 15.9651 44.4975 20.9579 43.44 22.126C37.5039 28.686 27.0835 63.051 25.8749 80.0523C24.6565 97.1924 28.0501 118.537 34.351 133.369C36.6367 138.746 37.7864 143.309 37.4928 145.827L37.0298 149.799L43.2152 145.911C47.8887 142.973 50.2236 140.375 52.7586 135.295C56.0049 128.789 56.1289 127.8 56.5183 105.231C56.888 83.7911 57.1889 81.084 60.2251 71.925C66.2718 53.6856 65.6048 40.019 58.104 28.4662C54.2829 22.5804 52.1863 15.8165 51.2516 6.3578C50.8119 1.9091 50.0884 -0.810223 49.6168 0.216587Z",
    fill: "url(#paint32_linear_4903_18557)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8822 146.863L38.9827 146.001C39.1611 144.471 38.895 142.491 38.3436 140.304C37.7838 138.083 36.8966 135.523 35.7314 132.782C29.5296 118.183 26.1684 97.0779 27.3711 80.1587C27.9637 71.8231 30.8338 59.106 34.3201 47.6089C36.0593 41.8733 37.94 36.4805 39.7465 32.1287C41.5808 27.7097 43.2621 24.5581 44.5522 23.1324C44.987 22.652 45.3663 21.9325 45.691 21.2044C46.035 20.4331 46.3854 19.4936 46.7244 18.4567C47.4028 16.3813 48.0607 13.8371 48.5406 11.3103L38.8822 146.863ZM38.8822 146.863L42.4169 144.641L43.2152 145.911L42.4169 144.641C44.6782 143.219 46.3097 141.92 47.6733 140.403C49.0384 138.885 50.1856 137.092 51.4165 134.625C53.0064 131.439 53.7662 129.74 54.2214 126.101C54.6943 122.32 54.8231 116.533 55.0185 105.205C55.203 94.507 55.3706 88.3929 55.881 83.8068C56.3985 79.1565 57.2683 76.0777 58.8013 71.453C64.7643 53.466 64.011 40.3187 56.8459 29.283L56.8458 29.2829C52.8563 23.1377 50.7092 16.122 49.7589 6.50531M38.8822 146.863L49.7589 6.50531M49.7589 6.50531C49.7345 6.25888 49.7093 6.01869 49.6835 5.78505M49.7589 6.50531L49.6835 5.78505M49.6835 5.78505C49.3071 7.45992 48.9079 9.37888 48.5406 11.3099L49.6835 5.78505Z",
    stroke: "url(#paint33_linear_4903_18557)",
    strokeOpacity: 0.3,
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.011 42.1127L101.011 42.1128C94.1371 45.1602 85.9295 50.2612 78.3727 55.9513C70.8093 61.6464 64 67.8548 59.8737 73.0753L58.6969 72.1452L59.8736 73.0754C54.3268 80.0929 43.398 97.503 38.5341 107.086C36.4577 111.178 35.1359 116.117 34.69 120.876C34.2422 125.657 34.6917 130.103 36.011 133.261C37.313 136.377 37.9665 140.035 37.9937 143.449C38.0046 144.81 37.9161 146.163 37.718 147.449C39.3345 145.353 41.2117 143.057 42.929 141.096C46.1957 137.365 51.5049 130.577 54.7036 126.042C57.9276 121.468 64.1583 112.625 68.5492 106.391C76.9281 94.4916 85.6109 85.2193 99.9681 72.7956C104.678 68.7199 107.511 65.651 109.469 61.9941C111.436 58.322 112.586 53.9392 113.703 47.112L113.703 47.1116C114.128 44.5255 114.786 41.7086 115.506 39.2435C116.215 36.8159 117.021 34.601 117.774 33.295M101.011 42.1127L119.074 34.0439M101.011 42.1127C104.471 40.5783 108.057 38.838 111.053 37.2675C114.008 35.7188 116.504 34.2761 117.699 33.3412C117.728 33.3181 117.758 33.2951 117.787 33.2722M101.011 42.1127L119.294 30.3426C119.287 30.3602 119.279 30.3781 119.271 30.3962C118.939 31.1518 118.418 32.1742 117.787 33.2722M117.774 33.295L119.074 34.0439M117.774 33.295C117.774 33.2952 117.774 33.2954 117.774 33.2956L119.074 34.0439M117.774 33.295C117.778 33.2874 117.783 33.2798 117.787 33.2722M119.074 34.0439C119.636 33.0673 120.122 32.1341 120.477 31.3693C120.463 31.3781 120.448 31.3871 120.433 31.3962C119.734 31.8287 118.796 32.4872 117.787 33.2722M120.671 30.9389C120.485 30.8935 120.236 30.7924 120.009 30.5668L120.671 30.9389Z",
    fill: "url(#paint34_linear_4903_18557)",
    stroke: "url(#paint35_linear_4903_18557)",
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.19 101.213L119.19 101.213C121.268 100.061 122.913 99.2397 124.114 98.7297C123.48 99.3405 122.624 100.094 121.53 100.991C117.903 103.961 111.656 110.895 107.6 116.421L108.406 117.013L107.6 116.421C103.055 122.613 99.3982 126.688 95.6214 129.465C91.8693 132.223 87.9461 133.739 82.8024 134.719C78.5218 135.533 72.7013 136.196 69.9033 136.197L69.9029 136.197C67.4996 136.199 65.8183 136.36 63.8805 137.311C62.0178 138.225 59.9562 139.852 56.6893 142.6L56.6891 142.6C52.6601 145.99 46.7906 150.907 43.647 153.527L43.647 153.527C41.1492 155.608 36.9829 158.314 33.3937 160.351C32.4544 160.885 31.5634 161.367 30.7602 161.778C31.5676 161.048 32.4998 160.231 33.4953 159.386L32.848 158.624L33.4954 159.386C36.307 156.998 39.6305 153.046 42.6834 148.696C45.7421 144.337 48.577 139.509 50.3893 135.331L50.3894 135.331C53.1598 128.944 58.5142 124.946 74.7763 117.89C83.3233 114.182 95.6199 109.567 102.076 107.642C108.592 105.699 116.292 102.818 119.19 101.213ZM125.987 98.1274C125.987 98.1275 125.984 98.1275 125.98 98.1271C125.985 98.1271 125.987 98.1273 125.987 98.1274ZM125.399 97.2504C125.402 97.2434 125.403 97.2423 125.401 97.2477C125.4 97.2485 125.4 97.2495 125.399 97.2504Z",
    fill: "url(#paint36_linear_4903_18557)",
    stroke: "url(#paint37_linear_4903_18557)",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2136 136.09L73.2136 136.09C74.3265 135.446 75.1998 134.993 75.8278 134.722C75.8745 134.702 75.9196 134.683 75.963 134.665C75.6251 135.028 75.1246 135.503 74.4474 136.088C72.5769 137.705 69.3652 141.494 67.2863 144.519L67.6984 144.803L67.2863 144.519C64.9545 147.912 63.0724 150.142 61.1196 151.653C59.1807 153.154 57.1461 153.966 54.473 154.474C52.2473 154.898 49.2183 155.227 47.7607 155.211L47.7605 155.211C46.5074 155.197 45.6298 155.275 44.6239 155.789C43.6585 156.282 42.5944 157.168 40.909 158.665L40.9089 158.665C38.8298 160.512 35.801 163.191 34.1787 164.619L34.1787 164.619C32.8891 165.753 30.734 167.222 28.876 168.325C28.2791 168.679 27.7198 168.992 27.2357 169.241C27.7064 168.784 28.2826 168.246 28.9072 167.686L28.5733 167.314L28.9072 167.686C30.3564 166.386 32.0628 164.226 33.626 161.844C35.1924 159.457 36.6384 156.811 37.5554 154.519L37.5554 154.519C38.966 150.993 41.7401 148.818 50.1669 145.025C54.5987 143.03 60.9791 140.558 64.332 139.535C67.7165 138.502 71.7126 136.959 73.2136 136.09ZM76.7323 134.429C76.7322 134.429 76.731 134.429 76.7287 134.429C76.7312 134.429 76.7323 134.429 76.7323 134.429Z",
    fill: "url(#paint38_linear_4903_18557)",
    stroke: "url(#paint39_linear_4903_18557)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82716 0.216587C5.29144 1.22989 6.43862 6.09618 7.37699 11.03C8.31414 15.9651 9.94648 20.9579 11.004 22.126C16.9401 28.686 27.3605 63.051 28.5691 80.0523C29.7875 97.1924 26.3939 118.537 20.093 133.369C17.8072 138.746 16.6576 143.309 16.9511 145.827L17.4142 149.799L11.2288 145.911C6.5553 142.973 4.22041 140.375 1.68532 135.295C-1.56092 128.789 -1.68498 127.8 -2.07433 105.231C-2.44403 83.7911 -2.74495 81.084 -5.78116 71.925C-11.8278 53.6856 -11.1609 40.019 -3.65999 28.4662C0.161074 22.5804 2.25768 15.8165 3.19237 6.3578C3.63208 1.9091 4.35552 -0.810223 4.82716 0.216587Z",
    fill: "url(#paint40_linear_4903_18557)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5617 146.863L15.4612 146.001C15.2829 144.471 15.5489 142.491 16.1003 140.304C16.6602 138.083 17.5474 135.523 18.7125 132.782C24.9144 118.183 28.2756 97.0779 27.0729 80.1587C26.4803 71.8231 23.6102 59.106 20.1239 47.6089C18.3847 41.8733 16.5039 36.4805 14.6975 32.1287C12.8631 27.7097 11.1819 24.5581 9.89176 23.1324C9.45694 22.652 9.07768 21.9325 8.75298 21.2044C8.40901 20.4331 8.05854 19.4936 7.7196 18.4567C7.04116 16.3813 6.38325 13.8371 5.90341 11.3103L15.5617 146.863ZM15.5617 146.863L12.0271 144.641L11.2288 145.911L12.0271 144.641C9.76574 143.219 8.13432 141.92 6.77067 140.403C5.40561 138.885 4.25838 137.092 3.02748 134.625C1.4376 131.439 0.67774 129.74 0.222567 126.101C-0.250296 122.32 -0.379135 116.533 -0.574553 105.205C-0.759029 94.507 -0.926641 88.3929 -1.43701 83.8068C-1.95452 79.1565 -2.82429 76.0777 -4.35736 71.453C-10.3203 53.466 -9.56704 40.3187 -2.4019 29.283L-2.40187 29.2829C1.5877 23.1377 3.73479 16.122 4.6851 6.50531M15.5617 146.863L4.6851 6.50531M4.6851 6.50531C4.70946 6.25888 4.73463 6.01869 4.7605 5.78505M4.6851 6.50531L4.7605 5.78505M4.7605 5.78505C5.13685 7.45992 5.53606 9.37888 5.90333 11.3099L4.7605 5.78505Z",
    stroke: "url(#paint41_linear_4903_18557)",
    strokeOpacity: 0.3,
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-58.4429 50.8244L-58.4427 50.8244C-51.2317 52.9548 -42.432 56.9486 -34.2012 61.6109C-25.9633 66.2773 -18.4065 71.5504 -13.6381 76.1919L-12.5919 75.117L-13.6381 76.1919C-7.22823 82.431 5.86561 98.2772 11.931 107.149C14.5204 110.937 16.4714 115.663 17.5306 120.324C18.5945 125.006 18.7253 129.473 17.8266 132.776C16.9395 136.034 16.7659 139.746 17.1815 143.135C17.3472 144.486 17.6103 145.815 17.9735 147.065C16.099 145.197 13.9398 143.163 11.9828 141.441C8.25995 138.166 2.11542 132.123 -1.64425 128.041C-5.43404 123.924 -12.7587 115.964 -17.9208 110.351C-27.7718 99.6386 -37.5836 91.5703 -53.4304 81.113C-58.6289 77.6824 -61.8355 75.0067 -64.2518 71.6346C-66.6782 68.2485 -68.3862 64.0517 -70.3798 57.4271L-70.3799 57.4267C-71.1358 54.9174 -72.1536 52.2096 -73.1874 49.8587C-74.2054 47.5435 -75.2919 45.4519 -76.2074 44.2545M-58.4429 50.8244L-77.399 45.1656M-58.4429 50.8244C-62.0724 49.7514 -65.8539 48.4909 -69.0285 47.322C-72.1587 46.1695 -74.8206 45.0626 -76.1267 44.2905C-76.159 44.2714 -76.1912 44.2524 -76.2234 44.2335M-58.4429 50.8244L-78.0976 41.5241C-78.0878 41.5406 -78.0777 41.5573 -78.0675 41.5742C-77.6405 42.2804 -76.9915 43.2267 -76.2234 44.2335M-76.2074 44.2545L-77.399 45.1656M-76.2074 44.2545C-76.2073 44.2547 -76.2071 44.2548 -76.207 44.255L-77.399 45.1656M-76.2074 44.2545C-76.2127 44.2475 -76.2181 44.2405 -76.2234 44.2335M-77.399 45.1656C-78.0831 44.2701 -78.6861 43.4078 -79.1372 42.6955C-79.1219 42.7024 -79.1063 42.7094 -79.0905 42.7165C-78.3415 43.0548 -77.3253 43.586 -76.2234 44.2335M-79.3851 42.2939C-79.207 42.2247 -78.9736 42.0923 -78.7777 41.8391L-79.3851 42.2939Z",
    fill: "url(#paint42_linear_4903_18557)",
    stroke: "url(#paint43_linear_4903_18557)",
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M-73.1064 119.533L-73.1066 119.533C-75.2249 119.029 -76.8275 118.752 -77.9226 118.666C-78.0061 118.659 -78.0856 118.654 -78.1612 118.65C-77.3859 119.21 -76.1422 119.934 -74.3879 120.805C-70.367 122.802 -62.6728 128.381 -57.2397 133.203L-57.9035 133.951L-57.2396 133.203C-51.1298 138.626 -46.6273 141.898 -42.6243 143.582C-38.6821 145.241 -35.1796 145.377 -30.9995 144.393C-27.4728 143.562 -22.8829 141.911 -20.8412 140.762L-20.8407 140.762C-19.0185 139.738 -17.5819 139.163 -15.5786 139.496C-13.7276 139.804 -11.4367 140.888 -7.81644 142.754L-7.81621 142.754C-3.32853 145.069 3.20007 148.417 6.69033 150.193L6.69037 150.193C9.4449 151.595 13.7153 153.036 17.2688 153.933C18.4416 154.229 19.5149 154.461 20.4137 154.612C19.276 153.936 17.8008 153.116 16.2017 152.28L16.665 151.394L16.2017 152.28C13.046 150.631 8.8383 147.352 4.66843 143.498C0.484761 139.632 -3.72785 135.126 -6.88852 130.969L-6.88854 130.969C-9.37409 127.7 -12.0438 125.504 -15.9231 123.924C-19.8473 122.325 -25.0463 121.341 -32.6257 120.59C-40.6102 119.799 -51.7768 119.514 -57.4028 119.949C-60.2913 120.173 -63.4835 120.239 -66.305 120.167C-69.1025 120.096 -71.6153 119.887 -73.1064 119.533ZM-78.9704 117.921C-78.9705 117.921 -78.9695 117.923 -78.9671 117.927C-78.9691 117.923 -78.9703 117.922 -78.9704 117.921Z",
    fill: "url(#paint44_linear_4903_18557)",
    stroke: "url(#paint45_linear_4903_18557)",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.08129 62.9609C-10.4384 52.5701 -11.7006 47.9339 -13.7456 34.7052L-13.7457 34.7051C-14.3296 30.9297 -14.7399 28.017 -14.9843 25.9136C-14.1649 26.7311 -13.1706 27.6565 -12.0515 28.6479C-9.32368 31.0644 -5.79886 33.9218 -2.12842 36.6449L-2.1284 36.6449C5.30683 42.1609 9.72658 45.6913 12.9578 49.0853C16.1532 52.4419 18.2226 55.7042 20.8753 60.7562C24.8834 68.3905 27.418 80.9854 27.894 96.4169C28.0852 102.628 29.0568 108.377 30.8443 113.795L30.8443 113.795C33.404 121.552 34.9084 126.711 35.6049 130.448C36.2958 134.155 36.1639 136.326 35.5607 138.163C35.0655 139.669 34.8496 141.695 34.8457 143.978C34.8423 145.943 34.9965 148.171 35.3038 150.547C35.2023 150.358 35.1022 150.176 35.0029 150.002C34.3489 148.855 33.6723 147.921 32.8128 147.237C31.045 145.83 28.8723 145.798 26.0425 145.81C19.4192 145.837 12.6987 140.971 8.54141 132.413L8.54134 132.413C6.74748 128.721 4.90705 122.048 3.36581 113.889C1.83256 105.772 0.619476 96.3188 0.0331111 87.1481C-0.28532 82.1667 -0.604675 78.9528 -1.46828 75.5412C-2.32688 72.1493 -3.7111 68.6118 -6.08129 62.9609ZM-6.08129 62.9609L-7.46459 63.5409L-6.08129 62.9609Z",
    fill: "url(#paint46_linear_4903_18557)",
    stroke: "url(#paint47_linear_4903_18557)",
    strokeWidth: 3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2175 121.124C21.0737 124.602 21.6254 127.795 22.9025 130.763L22.9026 130.763C24.6894 134.915 25.6909 137.644 26.0866 139.615C26.4714 141.531 26.2622 142.623 25.7085 143.585C25.1887 144.487 24.8958 145.673 24.7774 146.972C24.6577 148.286 24.7103 149.785 24.9341 151.364C24.9341 151.364 24.9341 151.364 24.9341 151.364L24.9746 151.651C24.0778 150.304 23.2997 149.345 22.2156 148.821C21.5311 148.49 20.7876 148.358 19.937 148.317C19.0972 148.277 18.0849 148.326 16.8447 148.401C10.8962 148.76 5.47023 146.26 2.48094 141.905L2.48085 141.904C1.19397 140.03 -0.0216025 136.518 -0.923597 132.113C-1.81785 127.746 -2.3794 122.626 -2.42769 117.63C-2.45407 114.896 -2.56665 113.08 -3.15214 111.172C-3.73024 109.287 -4.75411 107.364 -6.47906 104.371C-8.07482 101.602 -9.0563 99.6331 -9.77888 97.4824C-10.5037 95.3249 -10.9816 92.9445 -11.5256 89.3359L-11.5256 89.3358C-11.8681 87.0655 -12.0795 85.3847 -12.1695 84.2424C-12.0705 84.3106 -11.9671 84.38 -11.8598 84.4506C-11.1411 84.9234 -10.1991 85.4774 -9.10684 86.0756C-6.91958 87.2736 -4.08119 88.6751 -1.11437 89.9951L-1.11435 89.9951C4.90736 92.6742 8.47548 94.406 11.0402 96.1177C13.5618 97.8005 15.1312 99.4763 17.1091 102.106C20.0404 106.005 21.5655 112.692 21.2175 121.124ZM21.2175 121.124L22.2167 121.165M21.2175 121.124L22.2167 121.165M22.2167 121.165C22.5686 112.638 21.0427 105.674 17.9083 101.505L25.9242 151.224C25.4941 148.189 25.7349 145.542 26.5751 144.084C27.9874 141.63 27.3925 138.666 23.8211 130.368C22.6084 127.549 22.0784 124.507 22.2167 121.165Z",
    fill: "url(#paint48_linear_4903_18557)",
    stroke: "url(#paint49_linear_4903_18557)",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6925 78.959L59.6925 78.959C58.443 87.0982 57.6206 89.9298 54.6869 96.2749L59.6925 78.959ZM59.6925 78.959C60.0607 76.5622 60.3111 74.7336 60.4498 73.4342M59.6925 78.959L60.4498 73.4342M60.4498 73.4342C59.843 73.9699 59.0777 74.5889 58.2033 75.2561C56.2975 76.7101 53.8315 78.4243 51.2603 80.0528L51.2603 80.0528C46.0498 83.3527 42.9595 85.4682 40.7149 87.5155C38.5003 89.5354 37.0848 91.5114 35.2792 94.5882C32.5667 99.2109 30.9583 106.925 30.8575 116.454C30.817 120.315 30.2106 123.88 29.0134 127.228L29.0134 127.228C27.3104 131.989 26.3238 135.146 25.8888 137.431C25.459 139.688 25.5877 140.996 26.0322 142.109L60.4498 73.4342ZM26.3747 150.176C26.5157 149.928 26.6528 149.699 26.7879 149.488C27.2436 148.776 27.72 148.199 28.3275 147.784C29.5425 146.956 31.0378 146.969 33.0502 147.02C37.8684 147.142 42.5614 144.183 45.3516 139.021L45.3517 139.021C46.5581 136.789 47.7611 132.713 48.7318 127.691C49.6965 122.702 50.4132 116.879 50.6888 111.222C50.8387 108.143 51.0172 106.14 51.5854 104.02C52.1493 101.916 53.0872 99.7339 54.6869 96.275L26.3747 150.176ZM26.3747 150.176C26.5871 148.585 26.6769 147.088 26.6415 145.773C26.6032 144.349 26.4165 143.069 26.0324 142.109L26.3747 150.176Z",
    fill: "url(#paint50_linear_4903_18557)",
    stroke: "url(#paint51_linear_4903_18557)",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6465 152.033C23.8226 151.349 22.9534 150.632 22.0521 149.894L22.3689 149.507L22.0521 149.894C19.1263 147.498 16.1573 144.849 13.7113 142.494C11.2769 140.149 9.32719 138.063 8.46905 136.8L8.46902 136.8C5.66314 132.669 -2.81726 123.882 -10.6417 117.025C-12.1602 115.694 -13.17 114.944 -14.1215 114.529C-15.0518 114.124 -15.9631 114.023 -17.3216 114.083L-17.3434 113.583L-17.3216 114.083C-19.6087 114.183 -21.2845 115.102 -22.3627 116.728C-23.457 118.377 -23.9765 120.817 -23.7862 124.02L-23.7862 124.02C-23.4301 130.019 -20.8197 135.04 -15.4448 139.937C-12.5901 142.537 -10.0464 144.216 -6.62454 145.413C-3.18404 146.616 1.1654 147.34 7.64945 147.987C15.6676 148.787 20.6179 149.877 24.6465 152.033Z",
    fill: "url(#paint52_linear_4903_18557)",
    stroke: "url(#paint53_linear_4903_18557)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5727 158.606C30.4967 153.924 29.727 150.344 26.2689 143.236C22.3751 135.232 21.6865 131.952 22.7853 126.634C23.8215 121.62 25.957 118.143 29.5437 115.632C33.3434 112.972 36.492 113.012 38.3687 115.744C39.4482 117.316 39.5646 118.206 39.0501 120.963C37.7251 128.064 35.4657 136.297 33.9606 139.509C33.0874 141.373 31.757 147.013 30.9729 152.175C30.1956 157.293 29.4655 161.327 29.3496 161.14C29.2345 160.953 29.335 159.813 29.5727 158.606Z",
    fill: "url(#paint54_linear_4903_18557)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8305 116.042L29.8304 116.042C26.3658 118.468 24.2901 121.823 23.2749 126.735C22.7356 129.345 22.6402 131.423 23.1442 133.825C23.6523 136.246 24.7743 139.021 26.7186 143.017C28.4529 146.582 29.5309 149.297 30.0529 151.726C30.1619 152.233 30.2465 152.726 30.3079 153.212C30.3644 152.848 30.4213 152.477 30.4786 152.1C30.8727 149.506 31.4039 146.792 31.9467 144.49C32.4859 142.205 33.0466 140.281 33.5079 139.297L33.5079 139.297C34.9847 136.145 37.2351 127.965 38.5586 120.872C38.8155 119.495 38.8999 118.652 38.8114 117.974C38.726 117.32 38.4743 116.781 37.9566 116.027C37.1017 114.783 35.9907 114.183 34.671 114.166C33.3202 114.149 31.6858 114.743 29.8305 116.042Z",
    stroke: "url(#paint55_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5479 157.756C32.3474 155.385 32.6911 153.485 32.0239 149.597C31.2728 145.219 31.5992 143.479 33.6777 140.788C35.6375 138.252 37.9872 136.578 41.1139 135.49C44.4264 134.337 46.6183 134.544 47.2577 136.071C47.6254 136.949 47.4875 137.417 46.4484 138.816C43.7726 142.416 40.1645 146.547 38.3208 148.122C37.251 149.036 34.9313 151.879 33.1113 154.507C31.307 157.113 29.8026 159.16 29.7676 159.056C29.7332 158.952 30.0844 158.367 30.5479 157.756Z",
    fill: "url(#paint56_linear_4903_18557)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4484 138.816C43.7726 142.416 40.1645 146.547 38.3208 148.122C37.251 149.036 34.9313 151.879 33.1113 154.507C32.8554 154.877 32.6055 155.235 32.365 155.578C32.5122 155.179 32.6246 154.767 32.703 154.334C32.7088 154.302 32.7145 154.269 32.72 154.236M46.4484 138.816L46.0471 138.517M46.4484 138.816L46.0471 138.517C46.0471 138.517 46.0471 138.517 46.0471 138.517M46.4484 138.816C47.4875 137.417 47.6254 136.949 47.2577 136.071C46.6183 134.544 44.4264 134.337 41.1139 135.49C37.9872 136.578 35.6375 138.252 33.6777 140.788M46.0471 138.517C43.3782 142.108 39.7966 146.204 37.9961 147.742L37.9961 147.742C37.4236 148.231 36.5515 149.202 35.61 150.356C34.6708 151.507 33.6399 152.868 32.7291 154.181M46.0471 138.517C46.5709 137.813 46.8111 137.412 46.901 137.107C46.9753 136.855 46.9549 136.643 46.7965 136.264L46.7965 136.264C46.5698 135.723 46.0631 135.36 45.1411 135.273C44.2019 135.184 42.9045 135.396 41.2783 135.962L41.2783 135.962C38.24 137.019 35.9718 138.637 34.0734 141.094M32.7291 154.181C32.7262 154.199 32.7231 154.218 32.72 154.236M32.7291 154.181C32.7195 154.195 32.7098 154.209 32.7002 154.223L32.72 154.236M32.7291 154.181C32.9385 152.876 32.8411 151.402 32.5167 149.512M32.72 154.236L32.7002 154.223C32.4313 154.611 32.1692 154.987 31.9177 155.344L33.6777 140.788M29.7676 159.056C29.7701 159.063 29.7799 159.06 29.7966 159.046L29.7676 159.056ZM29.7676 159.056C29.7505 159.004 29.8287 158.834 29.9687 158.6C29.9722 158.602 29.9757 158.603 29.9792 158.605C30.0285 158.627 30.0701 158.656 30.1048 158.687C29.9513 158.882 29.8453 159.006 29.7969 159.046L29.7676 159.056ZM32.5167 149.512L32.0239 149.597L32.5167 149.512ZM32.5167 149.512C32.1433 147.335 32.0508 145.879 32.2811 144.652C32.5084 143.441 33.0593 142.407 34.0734 141.094M34.0734 141.094L33.6777 140.788M34.0734 141.094C34.0734 141.094 34.0734 141.094 34.0734 141.094L33.6777 140.788",
    stroke: "url(#paint57_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5248 157.489C19.7033 155.141 19.3522 153.279 20.0171 149.496C20.7655 145.237 20.4323 143.532 18.3285 140.867C16.3449 138.354 13.9696 136.676 10.8114 135.555C7.46561 134.368 5.2537 134.529 4.6118 136.008C4.24256 136.858 4.38274 137.317 5.43458 138.702C8.14324 142.267 11.794 146.367 13.6583 147.939C14.7401 148.851 17.0876 151.67 18.9304 154.269C20.7572 156.846 22.2801 158.873 22.3152 158.772C22.3497 158.671 21.994 158.094 21.5248 157.489Z",
    fill: "url(#paint58_linear_4903_18557)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6118 136.008C5.2537 134.529 7.46561 134.368 10.8114 135.555C13.9696 136.676 16.3449 138.354 18.3285 140.867M4.6118 136.008L19.5246 149.41M4.6118 136.008C4.24256 136.858 4.38274 137.317 5.43458 138.702L4.6118 136.008ZM18.3285 140.867L17.936 141.177M18.3285 140.867L17.936 141.177M18.3285 140.867C20.4323 143.532 20.7655 145.237 20.0171 149.496M17.936 141.177C18.9633 142.478 19.5204 143.497 19.7517 144.68C19.986 145.877 19.8966 147.293 19.5246 149.41M17.936 141.177C16.0136 138.742 13.718 137.117 10.6442 136.026L10.6442 136.026C8.99988 135.443 7.68605 135.211 6.73405 135.28C5.79473 135.349 5.292 135.696 5.07044 136.207L5.07043 136.207C4.91349 136.568 4.89496 136.768 4.96849 137.008C5.05925 137.306 5.30188 137.701 5.83269 138.399C8.53427 141.955 12.1587 146.021 13.9806 147.557L13.9806 147.557C14.5585 148.044 15.4403 149.007 16.3932 150.151C17.3461 151.296 18.3927 152.648 19.3166 153.95C19.1066 152.674 19.203 151.24 19.5246 149.41M20.0171 149.496L19.5246 149.41M20.0171 149.496C19.5859 151.949 19.582 153.594 20.1292 155.088L20.0171 149.496Z",
    stroke: "url(#paint59_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4647 161.697C13.8818 160.227 12.8435 158.642 12.0066 154.894C11.0639 150.673 10.1022 149.227 7.13708 147.572C4.34148 146.013 1.50409 145.374 -1.84244 145.55C-5.38783 145.737 -7.3686 146.735 -7.39426 148.346C-7.40909 149.273 -7.10337 149.644 -5.60096 150.519C-1.73216 152.772 3.21226 155.158 5.53682 155.895C6.8858 156.322 10.1349 158.025 12.8339 159.719C15.5095 161.398 17.6932 162.685 17.6869 162.579C17.6802 162.473 17.1301 162.076 16.4647 161.697Z",
    fill: "url(#paint60_linear_4903_18557)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.39426 148.346C-7.3686 146.735 -5.38783 145.737 -1.84244 145.55C1.50409 145.374 4.34148 146.013 7.13708 147.572M-7.39426 148.346L11.5186 155.003M-7.39426 148.346C-7.40909 149.273 -7.10337 149.644 -5.60096 150.519L-7.39426 148.346ZM7.13708 147.572L6.89348 148.009M7.13708 147.572L6.89348 148.009M7.13708 147.572C10.1022 149.227 11.0639 150.673 12.0066 154.894M6.89348 148.009C8.3414 148.817 9.24683 149.545 9.91392 150.548C10.5897 151.564 11.0502 152.906 11.5186 155.003M6.89348 148.009C4.18408 146.498 1.44095 145.878 -1.81612 146.05L-1.81614 146.05C-3.55853 146.141 -4.86082 146.431 -5.71335 146.861C-6.55452 147.284 -6.88546 147.798 -6.89432 148.354L-6.89432 148.354C-6.90062 148.748 -6.84123 148.94 -6.68096 149.134C-6.48311 149.374 -6.10753 149.645 -5.34934 150.087C-1.49065 152.334 3.41612 154.699 5.68782 155.418L5.68786 155.418C6.40837 155.647 7.59221 156.198 8.91121 156.889C10.2301 157.58 11.7154 158.428 13.0679 159.275C12.3846 158.178 11.9235 156.816 11.5186 155.003M12.0066 154.894L11.5186 155.003M12.0066 154.894C12.5493 157.325 13.1767 158.846 14.2551 160.015L12.0066 154.894Z",
    stroke: "url(#paint61_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9148 159.314C27.1117 158.097 26.9893 157.113 27.389 155.092C27.839 152.815 27.7213 151.915 26.7927 150.533C25.9172 149.232 24.8382 148.379 23.3781 147.837C21.8312 147.262 20.7868 147.385 20.4509 148.182C20.2576 148.64 20.313 148.882 20.7761 149.6C21.9686 151.449 23.5921 153.567 24.4331 154.371C24.9211 154.837 25.9608 156.296 26.7681 157.647C27.5684 158.986 28.2384 160.037 28.2572 159.983C28.2757 159.929 28.1216 159.628 27.9148 159.314Z",
    fill: "url(#paint62_linear_4903_18557)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2039 148.306L23.2039 148.306C22.4644 148.031 21.9029 147.946 21.5189 147.991C21.1615 148.034 20.9954 148.177 20.9116 148.376L20.9115 148.376C20.8372 148.552 20.8393 148.614 20.8547 148.681C20.8803 148.793 20.9623 148.966 21.1963 149.329C22.3828 151.168 23.9808 153.247 24.7786 154.009L24.7786 154.009C25.0603 154.279 25.4662 154.795 25.888 155.387C26.1447 155.747 26.4155 156.147 26.6796 156.557C26.7075 156.089 26.7835 155.576 26.8985 154.995L23.2039 148.306ZM23.2039 148.306C24.5651 148.811 25.5602 149.597 26.3778 150.812L23.2039 148.306ZM27.112 152.542C27.0364 151.963 26.8172 151.466 26.3778 150.813L27.112 152.542ZM27.112 152.542C27.1902 153.139 27.1215 153.866 26.8985 154.995L27.112 152.542Z",
    stroke: "url(#paint63_linear_4903_18557)",
    strokeOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-44 89.4125V54.8563C-32.0564 60.4441 -19.5316 68.3621 -12.5919 75.117C-10.0527 77.5886 -6.49463 81.529 -2.73738 85.946C-3.21018 80.2641 -4.05217 77.1407 -5.78116 71.925C-7.16321 67.7561 -8.19453 63.8261 -8.87368 60.1057C-12.1848 51.807 -13.4055 46.7239 -15.228 34.9344C-16.9349 23.8982 -17.1998 19.9809 -16.0855 22.2844C-15.3844 23.7327 -11.0727 27.7265 -5.70701 32.0011C-5.09305 30.8 -4.41075 29.6225 -3.65999 28.4662C0.161072 22.5804 2.25768 15.8165 3.19238 6.3578C3.63209 1.9091 4.35553 -0.810223 4.82717 0.216587C5.29145 1.22989 6.43862 6.09618 7.377 11.03C8.31415 15.9651 9.94648 20.9579 11.004 22.126C15.9313 27.5712 23.9482 52.1736 27.222 70.1016C30.4957 52.1736 38.5126 27.5712 43.4399 22.126C44.4974 20.9579 46.1298 15.9651 47.0669 11.03C48.0053 6.09618 49.1525 1.22989 49.6167 0.216587C50.0884 -0.810223 50.8118 1.9091 51.2515 6.3578C52.1862 15.8165 54.2828 22.5804 58.1039 28.4662C65.2536 39.4782 66.1943 52.4108 61.0301 69.3934C70.3382 59.0682 87.5498 46.4397 100.403 40.7415C107.263 37.6992 114.63 33.8376 116.774 32.1598C118.919 30.482 120.851 29.2857 121.067 29.5031C121.284 29.7193 120.386 31.7631 119.074 34.0439C117.759 36.3247 116.01 42.3137 115.184 47.3544C112.936 61.0812 110.464 65.6969 100.95 73.9298C86.6577 86.297 78.0662 95.4806 69.7755 107.255C65.4538 113.391 59.3497 122.054 56.0842 126.687C59.9379 123.715 65.6329 120.767 74.3782 116.973C82.9492 113.254 95.2847 108.624 101.791 106.684C108.296 104.744 115.908 101.888 118.705 100.338C127.359 95.5428 128.954 96.1999 122.163 101.765C118.625 104.663 112.435 111.525 108.406 117.013C99.2776 129.449 93.4937 133.701 82.9893 135.701C80.3218 136.209 77.0523 136.66 74.2634 136.931C72.3974 138.699 69.5827 142.061 67.6983 144.803C63.0176 151.614 60.0292 153.926 54.5664 154.965C52.3231 155.392 49.2583 155.728 47.755 155.711C45.3034 155.684 44.6348 156.025 41.2409 159.039C39.1615 160.886 36.132 163.566 34.5089 164.994C31.8636 167.322 25.7702 170.939 25.6393 170.26C25.611 170.113 26.9311 168.787 28.5733 167.314C29.9654 166.065 31.6299 163.968 33.1738 161.622C29.8873 163.445 27.265 164.595 27.1547 164.022C27.1169 163.826 28.504 162.45 30.514 160.655C30.1795 160.75 29.8288 160.827 29.4606 160.88C29.4074 161.08 29.3695 161.172 29.3496 161.14C29.3251 161.101 29.3104 161.018 29.3047 160.901C28.5488 160.994 27.8366 160.927 27.1726 160.748C26.506 160.928 25.7908 160.994 25.0317 160.9C23.0421 160.651 21.556 159.697 20.3696 158.936C18.6265 157.817 17.5302 157.113 16.434 159.671C15.8972 160.924 14.8911 160.508 13.6437 159.244C14.3229 160.244 15.2122 160.984 16.4646 161.697C17.1301 162.076 17.6802 162.473 17.6869 162.579C17.6931 162.685 15.5094 161.398 12.8339 159.719C10.1349 158.025 6.88574 156.322 5.53676 155.895C3.2122 155.158 -1.73222 152.772 -5.60101 150.519C-7.10343 149.644 -7.40915 149.273 -7.39432 148.346C-7.3801 147.453 -6.76547 146.749 -5.6169 146.266C-9.62868 145.054 -12.437 143.313 -15.5482 140.518C-17.3165 140.172 -18.5274 140.609 -20.351 141.634C-22.504 142.845 -27.1925 144.523 -30.7703 145.366C-35.4683 146.473 -39.4283 146.227 -44 144.062V118.867C-40.0462 119.003 -35.9881 119.252 -32.5271 119.595C-29.3876 119.906 -26.6375 120.258 -24.2044 120.681C-23.6605 116.253 -21.2862 113.756 -17.3434 113.583C-17.2251 113.578 -17.1096 113.574 -16.9968 113.571L-19.025 111.366C-26.4667 103.274 -33.8865 96.7015 -44 89.4125ZM69.5186 137.199C66.3286 137.229 64.7179 137.631 61.6286 139.907C62.5883 139.569 63.4574 139.279 64.186 139.057C65.954 138.517 67.8782 137.841 69.5186 137.199Z",
    fill: "url(#paint64_linear_4903_18557)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6266 144H-7.20287C-9.03411 152.605 -13.1773 172.111 -15.1001 181.289C-17.5036 192.763 -22.6539 220.874 -22.9973 223.742C-23.272 226.037 -2.51032 244.204 7.90485 253L34 250.132L32.6266 144Z",
    fill: "#412748"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0001 163C61.5002 157.001 2.40273 163 0.00284195 163C-2.66371 170.816 -8.69677 188.532 -11.4966 196.869C-14.9965 207.29 -22.4961 232.821 -22.9961 235.427C-23.3961 237.511 6.83585 254.011 22.0018 262L60 259.395C60 259.395 54.5 169 58.0001 163Z",
    fill: "url(#paint65_linear_4903_18557)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4903_18557",
    x1: 44.964,
    y1: 0,
    x2: 44.964,
    y2: 94.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4903_18557",
    x1: 29.7479,
    y1: 8.38911,
    x2: 55.471,
    y2: 126.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4903_18557",
    x1: 89.4973,
    y1: 32.5482,
    x2: 57.563,
    y2: 132.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820203,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4903_18557",
    x1: 42.3815,
    y1: 36.5685,
    x2: 50.7776,
    y2: 140.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4903_18557",
    x1: 72.2878,
    y1: 107.439,
    x2: 81.2245,
    y2: 153.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4903_18557",
    x1: 30.2688,
    y1: 118.228,
    x2: 38.5492,
    y2: 156.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4903_18557",
    x1: 58.7917,
    y1: 129.58,
    x2: 39.7539,
    y2: 155.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4903_18557",
    x1: 64.3188,
    y1: 135.721,
    x2: 55.4021,
    y2: 138.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4903_18557",
    x1: 9.47994,
    y1: 0,
    x2: 9.47994,
    y2: 94.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4903_18557",
    x1: 24.696,
    y1: 8.38911,
    x2: -1.027,
    y2: 126.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4903_18557",
    x1: -48.2663,
    y1: 39.8477,
    x2: -3.7024,
    y2: 134.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820203,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4903_18557",
    x1: -1.02701,
    y1: 37.7252,
    x2: 4.08012,
    y2: 141.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4903_18557",
    x1: -35.1324,
    y1: 107.44,
    x2: -21.5317,
    y2: 166.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4903_18557",
    x1: 0.939394,
    y1: 102.532,
    x2: 10.3491,
    y2: 151.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4903_18557",
    x1: 1.06414,
    y1: 24.5645,
    x2: 25.629,
    y2: 148.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316552,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4903_18557",
    x1: -12.2222,
    y1: 29.2187,
    x2: 31.3804,
    y2: 137.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4903_18557",
    x1: 1.76608,
    y1: 82.976,
    x2: 14.2244,
    y2: 150.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316552,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4903_18557",
    x1: -9.69434,
    y1: 86.1887,
    x2: 9.52685,
    y2: 147.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4903_18557",
    x1: 48.9206,
    y1: 72.4419,
    x2: 34.1583,
    y2: 148.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316552,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4903_18557",
    x1: 58.4526,
    y1: 75.5272,
    x2: 33.4184,
    y2: 143.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4903_18557",
    x1: -27.7997,
    y1: 125.281,
    x2: 25.0147,
    y2: 144.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339582,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4903_18557",
    x1: -34.5551,
    y1: 109.928,
    x2: 11.3128,
    y2: 102.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4903_18557",
    x1: 25.171,
    y1: 111.083,
    x2: 33.8509,
    y2: 150.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4903_18557",
    x1: 34.3759,
    y1: 104.406,
    x2: 55.3063,
    y2: 128.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4903_18557",
    x1: 39.1768,
    y1: 132.873,
    x2: 40.6797,
    y2: 153.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4903_18557",
    x1: 47.2586,
    y1: 129.96,
    x2: 53.5782,
    y2: 144.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4903_18557",
    x1: 12.7608,
    y1: 133.037,
    x2: 10.9766,
    y2: 152.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4903_18557",
    x1: 4.5974,
    y1: 130.042,
    x2: -1.60502,
    y2: 144.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4903_18557",
    x1: -1.00789,
    y1: 142.478,
    x2: 4.97793,
    y2: 161.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4903_18557",
    x1: -9.69585,
    y1: 142.843,
    x2: -9.94474,
    y2: 158.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4903_18557",
    x1: 24.3532,
    y1: 146.466,
    x2: 23.6525,
    y2: 157.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4903_18557",
    x1: 20.5812,
    y1: 145.011,
    x2: 17.064,
    y2: 152.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4903_18557",
    x1: 44.964,
    y1: 0,
    x2: 44.964,
    y2: 94.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4903_18557",
    x1: 29.7479,
    y1: 8.38911,
    x2: 55.471,
    y2: 126.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4903_18557",
    x1: 89.4973,
    y1: 32.5482,
    x2: 57.563,
    y2: 132.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820203,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4903_18557",
    x1: 42.3815,
    y1: 36.5685,
    x2: 50.7776,
    y2: 140.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4903_18557",
    x1: 72.2878,
    y1: 107.439,
    x2: 81.2245,
    y2: 153.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4903_18557",
    x1: 30.2688,
    y1: 118.228,
    x2: 38.5492,
    y2: 156.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4903_18557",
    x1: 58.7917,
    y1: 129.58,
    x2: 39.7539,
    y2: 155.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4903_18557",
    x1: 64.3188,
    y1: 135.721,
    x2: 55.4021,
    y2: 138.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4903_18557",
    x1: 9.47994,
    y1: 0,
    x2: 9.47994,
    y2: 94.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4903_18557",
    x1: 24.696,
    y1: 8.38911,
    x2: -1.027,
    y2: 126.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4903_18557",
    x1: -48.2663,
    y1: 39.8477,
    x2: -3.7024,
    y2: 134.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820203,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4903_18557",
    x1: -1.02701,
    y1: 37.7252,
    x2: 4.08012,
    y2: 141.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4903_18557",
    x1: -35.1324,
    y1: 107.44,
    x2: -21.5317,
    y2: 166.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4903_18557",
    x1: 0.939394,
    y1: 102.532,
    x2: 10.3491,
    y2: 151.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4903_18557",
    x1: 1.06414,
    y1: 24.5645,
    x2: 25.629,
    y2: 148.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316552,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4903_18557",
    x1: -12.2222,
    y1: 29.2187,
    x2: 31.3804,
    y2: 137.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4903_18557",
    x1: 1.76608,
    y1: 82.976,
    x2: 14.2244,
    y2: 150.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316552,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4903_18557",
    x1: -9.69434,
    y1: 86.1887,
    x2: 9.52685,
    y2: 147.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4903_18557",
    x1: 48.9206,
    y1: 72.4419,
    x2: 34.1583,
    y2: 148.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316552,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4903_18557",
    x1: 58.4526,
    y1: 75.5272,
    x2: 33.4184,
    y2: 143.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4903_18557",
    x1: -27.7997,
    y1: 125.281,
    x2: 25.0147,
    y2: 144.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464656,
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339582,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4903_18557",
    x1: -34.5551,
    y1: 109.928,
    x2: 11.3128,
    y2: 102.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4903_18557",
    x1: 25.171,
    y1: 111.083,
    x2: 33.8509,
    y2: 150.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4903_18557",
    x1: 34.3759,
    y1: 104.406,
    x2: 55.3063,
    y2: 128.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4903_18557",
    x1: 39.1768,
    y1: 132.873,
    x2: 40.6797,
    y2: 153.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4903_18557",
    x1: 47.2586,
    y1: 129.96,
    x2: 53.5782,
    y2: 144.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4903_18557",
    x1: 12.7608,
    y1: 133.037,
    x2: 10.9766,
    y2: 152.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4903_18557",
    x1: 4.5974,
    y1: 130.042,
    x2: -1.60502,
    y2: 144.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4903_18557",
    x1: -1.00789,
    y1: 142.478,
    x2: 4.97793,
    y2: 161.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4903_18557",
    x1: -9.69585,
    y1: 142.843,
    x2: -9.94474,
    y2: 158.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4903_18557",
    x1: 24.3531,
    y1: 146.466,
    x2: 23.6524,
    y2: 157.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10509,
    stopColor: "#7B865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4903_18557",
    x1: 20.5811,
    y1: 145.011,
    x2: 17.0639,
    y2: 152.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10205,
    stopColor: "#A5BA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667445,
    stopColor: "#A5BA6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4903_18557",
    x1: 47,
    y1: 200.5,
    x2: 36.5,
    y2: -10.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.209139,
    stopColor: "#3E2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4903_18557",
    x1: 31.5013,
    y1: 186.969,
    x2: 60.5946,
    y2: 192.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53335D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerPot);
export default __webpack_public_path__ + "static/media/flowerPot.be28d240a612c242b4e5da0a9a13ea09.svg";
export { ForwardRef as ReactComponent };